import { produce } from "immer";
import { Reducer } from "redux";
import {
  APPLY_X10_CONFIG,
  APPLY_X10_CONFIG_ERROR,
  APPLY_X10_CONFIG_SUCCESS,
  GET_X10_CONFIG,
  GET_X10_CONFIG_ERROR,
  GET_X10_CONFIG_HISTORY_SUCCESS,
  GET_X10_CONFIG_SUCCESS,
  IX10ConfigState,
  PING_X10_DONE,
  START_X10_CONFIG_POLLING,
  X10ConfigActionTypes
} from "./types";

export const initialState: IX10ConfigState = {
  configurations: {},
  history: {},
  loading: false,
  loadError: false,
  applying: false,
  applyBlocked: null,
  lastPing: null
};

const reducer: Reducer<IX10ConfigState, X10ConfigActionTypes> = (
  state = initialState,
  action: X10ConfigActionTypes
) =>
  produce(state, draft => {
    switch (action.type) {
      case START_X10_CONFIG_POLLING:
        draft.applyBlocked = null;
        draft.lastPing = null;
        break;
      case GET_X10_CONFIG:
        // Polls refresh in the background: only the first load shows a spinner.
        draft.loading = !state.configurations[action.payload];
        break;
      case GET_X10_CONFIG_SUCCESS:
        draft.loading = false;
        draft.loadError = false;
        draft.configurations[action.payload.x10Id] = action.payload;
        break;
      case GET_X10_CONFIG_ERROR:
        draft.loading = false;
        draft.loadError = true;
        break;
      case GET_X10_CONFIG_HISTORY_SUCCESS:
        draft.history[action.payload.x10Id] = action.payload.history;
        break;
      case PING_X10_DONE:
        draft.lastPing = action.payload;
        break;
      case APPLY_X10_CONFIG:
        draft.applying = true;
        draft.applyBlocked = null;
        break;
      case APPLY_X10_CONFIG_SUCCESS:
        draft.applying = false;
        break;
      case APPLY_X10_CONFIG_ERROR:
        draft.applying = false;
        draft.applyBlocked = action.payload;
        break;
      default:
        break;
    }
  });

export default reducer;
